import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { SchemasState } from "./types";
import {
  getSchemaMessagesAction,
  postSchemaMessageAction,
  postSchemaMessageToChatCompletion,
  uploadFileToSchemaDialogAction,
} from "./actions";

export function postSchemaMessageReducerBuilder(
  builder: ActionReducerMapBuilder<SchemasState>,
) {
  builder.addCase(postSchemaMessageAction.pending, (state, action) => {
    const { id } = action.meta.arg;
    state.isMessageLoading[id] = {
      ...state.isMessageLoading[id],
      isResponseMessageLoading: true,
    };
  });
  builder.addCase(postSchemaMessageAction.fulfilled, (state, action) => {
    const { id } = action.meta.arg;
    if (!action.payload) return;
    state.messages[id] = [
      ...state.messages[id],
      {
        role: "assistant",
        content: action.payload.systemMessageContent,
      },
    ];
    state.isMessageLoading[id] = {
      ...state.isMessageLoading[id],
      isResponseMessageLoading: false,
    };
  });
  builder.addCase(postSchemaMessageAction.rejected, (state, action) => {
    const { id } = action.meta.arg;
    state.isMessageLoading[id] = {
      ...state.isMessageLoading[id],
      isResponseMessageLoading: false,
    };
  });
}

export function postSchemaMessageToChatCompletionReducerBuilder(
  builder: ActionReducerMapBuilder<SchemasState>,
) {
  builder.addCase(
    postSchemaMessageToChatCompletion.pending,
    (state, action) => {
      const { id } = action.meta.arg;
      state.isMessageLoading[id] = {
        ...state.isMessageLoading[id],
        isCompletionMessageLoading: true,
      };
    },
  );
  builder.addCase(
    postSchemaMessageToChatCompletion.fulfilled,
    (state, action) => {
      const { id } = action.meta.arg;
      state.isMessageLoading[id] = {
        ...state.isMessageLoading[id],
        isCompletionMessageLoading: false,
      };
    },
  );
  builder.addCase(
    postSchemaMessageToChatCompletion.rejected,
    (state, action) => {
      const { id } = action.meta.arg;
      state.isMessageLoading[id] = {
        ...state.isMessageLoading[id],
        isCompletionMessageLoading: false,
      };
    },
  );
}

export function getSchemaMessagesReducerBuilder(
  builder: ActionReducerMapBuilder<SchemasState>,
) {
  builder.addCase(getSchemaMessagesAction.pending, (state, action) => {
    const { id } = action.meta.arg;
    state.isMessageLoading[id] = {
      ...state.isMessageLoading[id],
      isThreadMessageLoading: true,
    };
  });
  builder.addCase(getSchemaMessagesAction.fulfilled, (state, action) => {
    const { id } = action.meta.arg;
    if (!action.payload) return;
    state.messages[id] = action.payload;
    state.isMessageLoading[id] = {
      ...state.isMessageLoading[id],
      isThreadMessageLoading: false,
    };
  });
  builder.addCase(getSchemaMessagesAction.rejected, (state, action) => {
    const { id } = action.meta.arg;
    state.isMessageLoading[id] = {
      ...state.isMessageLoading[id],
      isThreadMessageLoading: false,
    };
  });
}
export function uploadFileToSchemaDialogReducerBuilder(
  builder: ActionReducerMapBuilder<SchemasState>,
) {
  builder.addCase(uploadFileToSchemaDialogAction.pending, (state) => {
    state.isFileLoading = true;
  });
  builder.addCase(uploadFileToSchemaDialogAction.fulfilled, (state) => {
    state.isFileLoading = false;
  });
  builder.addCase(uploadFileToSchemaDialogAction.rejected, (state) => {
    state.isFileLoading = false;
  });
}
